import { BlockFile } from "../../blocked";
import { QueovalBase, QueovalDate, QueovalDik } from "../../global";
import { ModelMail } from "../model-email/model-email.model";



export class SendMailModel extends QueovalBase {
  /**
   * Liste des destinataires 
   */
  public RecipientList: Recipient[];
  /**
   * Liste des documents générés automatiquement 
   */
  public ListDocAffected: DocAffected[];
  /**
   * Liste des libellés d'expéditeurs pour les sms
   */
  public SmsSendersList: string[];
  public LstModelesMail: Array<QueovalDik>;
  public AttachmentToPdf: boolean;
  public Attachments: { [key: string]: string };
  public Programed: QueovalDate;
  public ListDocuments: Array<BlockFile>;
  public ClientDocuments: Array<BlockFile>;
  public NewDocument: BlockFile;

  public BoDocAdded: QueovalDik;

  public Model: ModelMail;

  public IdPere: string;
  public IdClient: string;

  public IdContactPrincipal: string;
  public Destinataire: string;
  public SelectedModel: string;

  public ListGroupDoc: string[];

  // Message d'info pour l'envoi des mail auto
  public MsgSendMailAuto: string;

  /**
   * type : STAGE / ACTIONCO...
   */
  public type: string;
}

export class RecipientModel extends QueovalBase
{ 
  public Recipient: Recipient;
  public LstRecipient: Array<Recipient>;
}

export class Recipient {
  public Ident: string;
  public Mails: Array<QueovalDik>;
  public Tels: Array<QueovalDik>;
  // libellé complet
  public Value: string;
  public TypeRecipient: string;
}



export class DocAffected {
  public Ident: string;
  public Value: string;
  public Code: string;
  public TypeDocAffected: string;
}


